var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoElakay1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 1728 1728",
    style: {
      enableBackground: "new 0 0 1728 1728"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st2{fill:#FFFFFF;}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 1171,
    className: "st0",
    width: 236,
    height: 236
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 1445,
    className: "st0",
    width: 236,
    height: 236
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874,
    y: 1171,
    className: "st0",
    width: 236,
    height: 236
  }), /*#__PURE__*/React.createElement("rect", {
    x: 874,
    y: 1445,
    className: "st0",
    width: 236,
    height: 236
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "860.56,34.8 477.14,810.88 475.6,444.39 230.77,444.39 232.31,1306.7 41.37,1682.42 330.86,1685.5  859.02,578.36 1394.88,1693.2 1685.91,1690.12 1686.63,1691.82  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoElakay1);
export default __webpack_public_path__ + "static/media/LogoElakay1.05e83f40d30e2389306d96edc76519ea.svg";
export { ForwardRef as ReactComponent };